export default "__VITE_ASSET__Cbesf2dd__"